// client/src/pages/admin/AdminSettings.js
import { useState } from "react";
import api from "../../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function AdminSettings() {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [show, setShow] = useState(false);

  const changePassword = async () => {
    if (!oldPass || !newPass) return toast.error("Both fields required");

    try {
      await api.put("/user/change-password", {
        oldPassword: oldPass,
        newPassword: newPass,
      });
      toast.success("Password updated");
      setOldPass("");
      setNewPass("");
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div className="max-w-md space-y-4">
      <h1 className="text-2xl font-bold">Admin Settings</h1>

      <input
        type={show ? "text" : "password"}
        className="input-glass"
        placeholder="Old password"
        value={oldPass}
        onChange={(e) => setOldPass(e.target.value)}
      />

      <input
        type={show ? "text" : "password"}
        className="input-glass"
        placeholder="New password"
        value={newPass}
        onChange={(e) => setNewPass(e.target.value)}
      />

      <div className="flex items-center gap-4">
        <button
          onClick={() => setShow(!show)}
          className="text-sm text-purple-400 underline"
        >
          {show ? "Hide password" : "Show password"}
        </button>

        <button onClick={changePassword} className="btn-primary">
          Change Password
        </button>
      </div>
    </div>
  );
}
